import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getBroadcasts } from 'api/broadcasts.service';
import { useToast } from 'hooks/ui';
import { Broadcast } from 'models/broadcast.model';
import { setBroadcasts, useBroadcastStore } from 'store/broadcast';
import { DURATIONS } from 'common/constants';
import { broadcastKeys } from './queryKeys';
import { AllStatuses } from 'interfaces';

export const useBroadcastById = (id: string) => {
  const queryClient = useQueryClient();
  const all = queryClient.getQueryData<Broadcast[]>(broadcastKeys.all);
  const active = all?.filter((b) => b.id === id);

  return active ? active[0] : null;
};

export const useBroadcastGetAllQuery = () => {
  const draft = useBroadcastStore((state) => state.draft);
  const toast = useToast();

  const isDraftSaved = draft.status !== AllStatuses.NOT_SAVED;

  const query = useQuery({
    queryKey: broadcastKeys.all,
    queryFn: () => getBroadcasts({}),
    staleTime: 0,
    refetchInterval: isDraftSaved && DURATIONS.MINUTES_5,
    refetchIntervalInBackground: isDraftSaved,
    refetchOnReconnect: isDraftSaved,
    refetchOnWindowFocus: isDraftSaved,
  });

  const { data, error } = query;

  useEffect(() => {
    if (data) {
      setBroadcasts(data);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      toast.error(error.message);
    }
  }, [error, toast]);

  return query;
};
